/* eslint-disable @typescript-eslint/no-explicit-any */
// PlatformOps (CloudOps) widget registry entries (simple definitions for the widget picker / registry).
// These are distinct from the rich PLATFORMOPS_WIDGETS in platformopsWidgets.ts which include getData functions.

import {
  REGISTRY_WIDGET_CATEGORIES,
  REGISTRY_WIDGET_SIZES,
  REGISTRY_WIDGET_TYPES,
  REGISTRY_ICONS,
} from './widgetRegistryConstants';

const C = REGISTRY_WIDGET_CATEGORIES;
const S = REGISTRY_WIDGET_SIZES;
const T = REGISTRY_WIDGET_TYPES;

export const PLATFORMOPS_REGISTRY_WIDGETS = [
  // PLATFORMOPS WIDGETS
  {
    id: 'platform-health',
    name: 'Platform Health Score',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.MEDIUM,
    description: 'Overall operational status',
    icon: REGISTRY_ICONS.FiZap,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'total-cloud-spend',
    name: 'Total Cloud Spend',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.MEDIUM,
    description: 'Current month cloud expenditure',
    icon: REGISTRY_ICONS.FiCloud,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'compliance-score',
    name: 'Compliance Score',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.MEDIUM,
    description: 'Overall compliance rate',
    icon: REGISTRY_ICONS.FiCheckCircle,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'cost-by-service',
    name: 'Cost by AWS Service',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Service-level cost breakdown',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'active-environments',
    name: 'Active Endpoints',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Number of active endpoints',
    icon: REGISTRY_ICONS.FiMonitor,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'open-violations',
    name: 'Open Violations',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Active policy violations',
    icon: REGISTRY_ICONS.FiAlertOctagon,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'estimated-savings',
    name: 'Estimated Savings',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.MEDIUM,
    description: 'Potential cost reduction',
    icon: REGISTRY_ICONS.FiZap,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },

  // PLATFORMOPS WIDGETS (Additional)
  {
    id: 'environment-health',
    name: 'Environment Health',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Health status by environment',
    icon: REGISTRY_ICONS.FiActivity,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'tag-compliance',
    name: 'Tag Compliance',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Resource tagging compliance rate',
    icon: REGISTRY_ICONS.FiTag,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'cost-anomalies',
    name: 'Cost Anomalies',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Unusual spending patterns detected',
    icon: REGISTRY_ICONS.FiAlertTriangle,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'monthly-cost-trend',
    name: 'Monthly Cost Trend',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.LARGE,
    description: 'Historical spending pattern',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'service-cost-breakdown-alt',
    name: 'Service Cost Breakdown',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Service-level cost breakdown',
    icon: REGISTRY_ICONS.FiTool,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'ri-utilization',
    name: 'RI Utilization',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Reserved Instance usage',
    icon: REGISTRY_ICONS.FiArchive,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'spot-savings',
    name: 'Spot Savings',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Cost reduction from spot',
    icon: REGISTRY_ICONS.FiDollarSign,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'cost-savings-opportunities',
    name: 'Savings Opportunities',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.MEDIUM,
    description: 'Potential cost savings',
    icon: REGISTRY_ICONS.FiZap,
    dataSource: 'platformops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'violations-by-severity',
    name: 'Violations by Severity',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Critical/High/Medium/Low breakdown',
    icon: REGISTRY_ICONS.FiAlertTriangle,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'violations-by-category',
    name: 'Violations by Category',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Security/Cost/Governance breakdown',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'environment-uptime',
    name: 'Environment Uptime',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Average uptime percentage',
    icon: REGISTRY_ICONS.FiZap,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'active-users-count',
    name: 'Active Users',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Total active user accounts',
    icon: REGISTRY_ICONS.FiUsers,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'pending-access-requests',
    name: 'Pending Access Requests',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Awaiting approval',
    icon: REGISTRY_ICONS.FiLock,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'burn-rate-vs-planned',
    name: 'Burn Rate vs Planned',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.LARGE,
    description: 'Actual vs planned spending',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'enforcement-mode',
    name: 'Enforcement Mode',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.SMALL,
    description: 'Prevent vs Alert rules',
    icon: REGISTRY_ICONS.FiShield,
    dataSource: 'platformops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'compliance-trend',
    name: 'Compliance Trend',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.LARGE,
    description: 'Historical compliance rate',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'total-users',
    name: 'Total Users',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'All users in system',
    icon: REGISTRY_ICONS.FiUsers,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'roles-configured',
    name: 'Roles Configured',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Number of unique roles',
    icon: REGISTRY_ICONS.FiLock,
    dataSource: 'platformops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'user-activity-rate',
    name: 'User Activity Rate',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Active/Total ratio',
    icon: REGISTRY_ICONS.FiZap,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'access-by-role',
    name: 'Access by Role',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Users per role',
    icon: REGISTRY_ICONS.FiUsers,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'failed-logins',
    name: 'Failed Logins',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Security monitoring',
    icon: REGISTRY_ICONS.FiAlertTriangle,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'healthy-environments',
    name: 'Healthy Endpoints',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Count of healthy endpoints',
    icon: REGISTRY_ICONS.FiCheckCircle,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'degraded-environments',
    name: 'Degraded Endpoints',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Endpoints with issues',
    icon: REGISTRY_ICONS.FiAlertTriangle,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'down-environments',
    name: 'Down Endpoints',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Unavailable endpoints',
    icon: REGISTRY_ICONS.FiXCircle,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'tag-compliance-rate',
    name: 'Tag Compliance Rate',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.MEDIUM,
    description: 'Overall tagging compliance',
    icon: REGISTRY_ICONS.FiTag,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'tagged-resources',
    name: 'Tagged Resources',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Resources with tags',
    icon: REGISTRY_ICONS.FiCheckCircle,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'untagged-resources',
    name: 'Untagged Resources',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Resources missing tags',
    icon: REGISTRY_ICONS.FiAlertTriangle,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'tag-coverage',
    name: 'Tag Coverage',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Coverage per tag type',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'cost-allocation-rate',
    name: 'Cost Allocation',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Cost allocated via tags',
    icon: REGISTRY_ICONS.FiDollarSign,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'spending-anomalies',
    name: 'Spending Anomalies',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Unusual spending patterns',
    icon: REGISTRY_ICONS.FiAlertOctagon,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'rightsizing-recommendations',
    name: 'Rightsizing Recs',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Instance optimization',
    icon: REGISTRY_ICONS.FiCrop,
    dataSource: 'platformops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'idle-resources',
    name: 'Idle Resources',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Unused resource count',
    icon: REGISTRY_ICONS.FiMoon,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'system-uptime',
    name: 'System Uptime',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Platform availability',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'platformops',
    refreshRate: 60000,
    supportsDateFilter: false
  },
  {
    id: 'monthly-budget',
    name: 'Monthly Budget',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Budget allocation',
    icon: REGISTRY_ICONS.FiDollarSign,
    dataSource: 'platformops',
    refreshRate: 86400000,
    supportsDateFilter: false
  },
  {
    id: 'budget-alerts',
    name: 'Budget Alerts',
    category: C.PLATFORMOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Budget threshold alerts',
    icon: REGISTRY_ICONS.FiBell,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'alert-volume',
    name: 'Alert Volume',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Alerts over time',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'platformops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'cloud-spend-trend',
    name: 'Cloud Spend Trend',
    category: C.PLATFORMOPS,
    type: T.CHART,
    defaultSize: S.LARGE,
    description: 'Historical spending',
    icon: REGISTRY_ICONS.FiDollarSign,
    dataSource: 'platformops',
    refreshRate: 600000,
    supportsDateFilter: true
  },
];
